/*
 * @Date: 2021-07-05 15:40:06
 * @LastEditors: wangyu
 * @LastEditTime: 2021-07-23 10:13:49
 * @FilePath: \qrcode\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

const JumpMarket = [
  {
    path: '/',
    name: 'JumpMarket',
    component: () => import('@/views/Jump-market'),
    meta: { keepAlive: false }
  }
]

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [...JumpMarket]
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
